<template>
    <div>
        <draggable v-if="epics.length" v-model="stateEpics" class="dragArea" :options="{group:'epics-rows', ghostClass: 'ghost-class', handle: '.dragEpic', disabled: isSigned}" @update="epicsReordered">
            <epic-item v-for="(epic, index) in epics" :key="epic.id" :index="index" :initial-epic="epic" :costingline="getLineByEpicId(epic.id)" @deleted="deleteEpic"></epic-item>
        </draggable>

        <div class="row row-epic-heading" v-if="!isSigned">
            <div class="col-5 epic-heading">
                <div class="move-epic">
                <i class="mi drag_handle dragEpic"></i>
                </div>
                <input v-model="newEpic.title" type="text" class="add-epic form-control" placeholder="Add Heading..." @keyup.enter.prevent="handleCreateEpic" v-if="!isSigned" />
            </div>
            <div class="col flex-cell"></div>
            <div class="col flex-cell text-strong"></div>
            <div class="col flex-cell adjustment"></div>
            <div class="col flex-cell cost"></div>
            <div class="col-1 options"></div>
        </div>
    </div>

</template>

<script>

    import { http } from 'utils'
    import draggable from 'vuedraggable'
    import { mapState, mapActions, mapGetters } from 'vuex'

    import EpicItem from 'components/opportunities/epics/Epic.vue'

    import Story from './../../../models/story.js'
    import Epic from './../../../models/epic.js'

  export default {

    components: {
      draggable,
      EpicItem
    },

    data () {
      return {
        newEpic: new Epic()
      }
    },

    computed: {
      ...mapState('costing', ['costing']),
      ...mapState('epics', ['epics']),
      ...mapGetters('costing', ['getLineByEpicId', 'getLineByStoryId']),
      ...mapGetters('opportunity', ['isSigned']),

      stateEpics: {
        get () {
          return this.epics
        },

        set (value) {
          this.setEpics(value)
        }
      },
    },

    methods: {
        ...mapActions('epics', ['addEpic', 'reorderEpics', 'setEpics']),

        deleteEpic(id) {
            var epicIndex = this.epics.findIndex(x => x.id === id)

            if (epicIndex >= 0) {
                this.epics.splice(epicIndex, 1)
                this.epicsReordered();
            }
        },

        epicOrderArray () {
            var epicOrderArray = []

            for (var i = 0; i < this.epics.length; i++) {
                var epic = this.epics[i]
                epicOrderArray.push({id: epic.id})
            }

            return {epics: epicOrderArray}
        },

        handleCreateEpic () {

            this.addEpic({
                id: this.costing.user_story_document_id,
                payload: this.newEpic
            }).then((response) => {
                //reset the form data
                this.newEpic = new Epic()

                this.$bus.$emit('updateCosting')
            }).catch((response) => {

            })
        },

        saveEpicOrder () {
            if (!this.epics.length) return

            // Use the document the epics actually belong to - costing state can be
            // stale mid-navigation and must never re-parent epics to another document
            return this.reorderEpics({
                id: this.epics[0].user_story_document_id,
                payload: this.epicOrderArray()
            })
        },

        epicsReordered (event) {
            this.saveEpicOrder()
        }
    }
  }

</script>

<style scoped>

    .form-control {
        text-align: left;
}

</style>
